interface SEOHeadProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalUrl?: string;
  ogType?: string;
  ogImage?: string;
}

export default function SEOHead({ title, description, keywords, canonicalUrl, ogType = 'website' }: SEOHeadProps) {
  const fullTitle = `${title} - 久久视频`;
  const fullDescription = description.length > 160 ? description.slice(0, 157) + '...' : description;
  const defaultKeywords = '久久视频,久久视频在线观看,久久视频高清播放';
  const fullKeywords = keywords ? `${defaultKeywords},${keywords}` : defaultKeywords;

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={fullDescription} />
      <meta name="keywords" content={fullKeywords} />
      {canonicalUrl && <link rel="canonical" href={`https://jiujiu.video${canonicalUrl}`} />}
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={fullDescription} />
      <meta property="og:url" content={canonicalUrl ? `https://jiujiu.video${canonicalUrl}` : 'https://jiujiu.video'} />
      <meta property="og:site_name" content="久久视频" />
      <meta property="og:locale" content="zh_CN" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={fullDescription} />
    </>
  );
}